import { z } from 'zod'

export const PersonaType = z.enum([
  'THERAPIST',
  'PATIENT',
  'RESPONSIBLE',
  'ADMIN',
  'OPERATIONAL',
  'SUPERADMINISTRATOR'
])
export type PersonaType = z.infer<typeof PersonaType>

export const PersonaInfoSummary = z.object({
  userId: z.string(),
  username: z.string(),
  avatarUrl: z.string(),
  personaType: PersonaType.nullish(),
  avatarName: z.string().nullish()
})
export type PersonaInfoSummary = z.infer<typeof PersonaInfoSummary>

export const PersonaInfoSummaryList = PersonaInfoSummary.array()
export type PersonaInfoSummaryList = z.infer<typeof PersonaInfoSummaryList>
